import React, { useMemo } from 'react';
import { getCalendlyUrl } from '../../lib/attribution';
import { CALENDLY_URL, CONTACT_CHANNELS } from '../../lib/analytics.constants';
import { trackEvent } from '../../lib/analytics';

export default function CalendlyLink({
  ctaId,
  ctaLocation,
  deckLang,
  className,
  children,
  baseUrl = CALENDLY_URL,
  onClick,
  ...props
}) {
  const href = useMemo(() => getCalendlyUrl(baseUrl, ctaId), [baseUrl, ctaId]);

  const handleClick = (event) => {
    trackEvent('meeting_click', {
      cta_id: ctaId,
      cta_location: ctaLocation,
      contact_channel: CONTACT_CHANNELS.CALENDLY,
      ...(deckLang ? { deck_lang: deckLang } : {}),
    });
    onClick?.(event);
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  );
}
